import { Injectable } from '@angular/core';

import { CognitoUser, CognitoUserPool, AuthenticationDetails } from 'amazon-cognito-identity-js';

import { environment } from '../../../environments/environment';

import * as AWS from 'aws-sdk';

@Injectable()
export class CognitoService {
  email: string;
  userPoolId: string;
  clientId: string;
  cognito: CognitoUser;
  region: string;
  identityPoolId: string;
  idpUrl: string;
  azureAppId: string;
  siteUrl: string;
  finalizingLogin: boolean;

  constructor() {
    this.email = '';
    this.userPoolId = environment.cognito.userPoolId;
    this.clientId = environment.cognito.clientId;
    this.region = environment.cognito.region;
    this.identityPoolId = environment.cognito.identityPoolId;
    this.idpUrl = environment.cognito.idpUrl;
    this.azureAppId = environment.cognito.azureAppId;
    this.siteUrl = environment.siteUrl;
    this.finalizingLogin = false;
  }

  public authenticateUser(email: string, password: string, onSuccess, onFailure) {
    this.generateCognito(email);
    // this.cognito.setAuthenticationFlowType('');
    this.cognito.authenticateUser(this.generateAuthentication(password), {
      onSuccess: onSuccess,
      onFailure: onFailure
    });
  }

  public logout() {
    sessionStorage.setItem('loggedIn', 'false');
    sessionStorage.setItem('accessKeyId', '');
    sessionStorage.setItem('secretAccessKey', '');
    sessionStorage.setItem('sessionToken', '');
    this.finalizingLogin = false;
    location.reload();
  }

  public isAuthenticated(): boolean {
     return sessionStorage.getItem('loggedIn') === 'true';
    //  return true;
  }

  public isFinalizingLogin(): boolean {
    return this.finalizingLogin;
  }

  public getJwtToken(): string {
    if (!this.cognito) {
      return '';
    }

    return this.cognito.getSession((err, session) => {
      if (err) {
        return '';
      }
      return session.getIdToken().getJwtToken();
    });
  }

  generateCognito(email: string) {
    this.email = email;

    this.cognito = new CognitoUser({
      Username: this.email,
      Pool: new CognitoUserPool({
        UserPoolId: this.userPoolId,
        ClientId: this.clientId
      })
    });
  }

  generateAuthentication(password: string) {
    return new AuthenticationDetails({
      Username: this.email,
      Password: password,
    });
  }

  public authenticateWithIdToken(idToken: string) {
    this.finalizingLogin = true;
    let AWSCredentials = {
      IdentityPoolId: '',
      Logins: {}
    }
    AWSCredentials.IdentityPoolId = this.identityPoolId;
    if (!idToken) {
      return;
    }
    AWSCredentials.Logins[this.idpUrl + '/v2.0'] = idToken;
    AWS.config.region = this.region;

    AWS.config.credentials = new AWS.CognitoIdentityCredentials(AWSCredentials);

    // Obtain AWS credentials
    (<AWS.CognitoIdentityCredentials>AWS.config.credentials).get(err => {
      // history.replaceState({}, 0, window.location.pathname);
      if (err) {
        console.log('You are NOT logged into COGNITO.');
        sessionStorage.setItem('loggedIn', 'false');
      } else {
        if (AWS.config.credentials.accessKeyId) {
          console.log('You are logged into COGNITO.');
          let accessKeyId = AWS.config.credentials.accessKeyId;
          let secretAccessKey = AWS.config.credentials.secretAccessKey;
          let sessionToken = AWS.config.credentials.sessionToken;
          sessionStorage.setItem('loggedIn', 'true');
          sessionStorage.setItem('accessKeyId', accessKeyId);
          sessionStorage.setItem('secretAccessKey', secretAccessKey);
          sessionStorage.setItem('sessionToken', sessionToken);
          localStorage.setItem('region-api', 'https://' + environment.internalHost);
          localStorage.setItem('region-id', environment.cognito.region);
        }
      }
      this.finalizingLogin = false;
      location.reload();
    });
  }

  public authAzure() {
    var idpUrl = this.idpUrl;
    var path = '/oauth2/v2.0/authorize';
    var query = {
      client_id: this.azureAppId,  // Azure App ID
      redirect_uri: this.siteUrl, // Current URL
      nonce: 'qwerty', // A unique request identifier: https://security.stackexchange.com/questions/113491/purpose-of-nonce-validation-in-openid-connect-implicit-flow
      response_type: 'id_token',
      response_mode: 'fragment',
      scope: 'openid email profile'
    }

    var openIdProviderUrl = 'https://' + idpUrl + path + '?' + this.serializeObj(query);


    var azureResponse = this.parseQuery(location.hash);
    if (azureResponse && azureResponse['id_token']) {
      console.log(azureResponse);
    } else {
      console.log("You are NOT logged into AZURE.");

      if (!openIdProviderUrl)
        throw new Error('no openIdProviderUrl provided (Identity Provider URL) provided');
      window.location.href = openIdProviderUrl;
    }
  }
  /*
  * convert json into uri query format
  */
  private serializeObj(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  /*
  * convert uri query format into json
  */
  private parseQuery(query) {
    if (!query) return;
    query = query.replace('#', '');
    query = query.split('&');
    var result = {};
    query.forEach(function (param) {
      param = param.split('=');
      result[param[0]] = param[1];
    });
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cognito/cognito.service.ts